<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <p-toolbar>
    <ng-template #start>
      <div class="flex space-x-2 toolbar-menu">
        <p-selectButton [options]="tablePlot" [(ngModel)]="tablePlotSelected"
          (onChange)="onTablePlotSelect($event)" [allowEmpty]="false">
        </p-selectButton>

        @if (tablePlotSelected === 'plot') {
          <p-selectButton [options]="northingUdt"
            [(ngModel)]="northingUdtSelected" (onChange)="onNorthingUdtSelect($event)"
            [allowEmpty]="false">
          </p-selectButton>
        }
      </div>
    </ng-template>
  </p-toolbar>

  @if (tablePlotSelected === 'table') {
  <div class="w-full h-full">
    <form [formGroup]="formationTopsForm" novalidate>
      <div [style.display]="tablePlotSelected === 'table' ? 'block' : 'none'">
        <ng-container formArrayName="formationTops">
          <p-contextMenu #cm [model]="contextMenuItems()" appendTo="body"></p-contextMenu>
          <p-table [scrollable]="true" [scrollHeight]="tableHeight" [columns]="columnDefs" [resizableColumns]="true"
            [contextMenu]="cm" (onContextMenuSelect)="onFormationContextMenu($event.data)"
            [appAutoTableHeight]="true"
            [appAutoTableHeightContainerSelector]="'.grid-stack-item-content'"
            [appAutoTableHeightOffset]="65"
            (appAutoTableHeightChange)="tableHeight = $event"
            class="pr-2"
            [value]="formationTops.controls" showGridlines dataKey="value.id">
            <ng-template #header let-columns>
              <tr>
                @for (col of columns; track $index) {
                <th class="text-center" pResizableColumn> {{ col.header }} </th>
                }
                <th class="text-center w-[70px]">
                  <p-button class="outlined-button pl-4" outlined="true" size="small" severity="success" icon="pi pi-plus" [disabled]="formationTops.invalid"
                    title="Add" (click)="onAddFormation()"></p-button>
                </th>
              </tr>
            </ng-template>

            <ng-template #body let-formationTopFg let-rIdx="rowIndex">
              <ng-container [formGroupName]="rIdx">
                <tr [pContextMenuRow]="formationTopFg">
                  <td>
                    <p-inputNumber class="text-right w-full" formControlName="formationTop" [minFractionDigits]="1"
                      [title]="!isControlInvalid(formationTopFg, 'formationTop') ? 'Formation Top' : getControlErrors(formationTopFg, 'formationTop')">
                    </p-inputNumber>
                    <app-validation-error [isValid]="isControlInvalid(formationTopFg, 'formationTop')"
                      [errorMsg]="getControlErrors(formationTopFg, 'formationTop')"/>
                  </td>
                  <td>
                    <p-select filter filterBy="name" class="w-full" resetFilterOnHide="true" [title]="showJson(formationTopFg.get('formation').value)"
                      [options]="_formations" appendTo="body" formControlName="formation"
                      [placeholder]="getPlaceholderText(formationTopFg.get('formation').value)">
                      <ng-template let-formation pTemplate="selectedItem">
                        {{ getPlaceholderText(formationTopFg.get('formation').value) }}
                      </ng-template>
                      <ng-template let-formation pTemplate="item">
                        {{ formation.name }}
                      </ng-template>
                    </p-select>
                  </td>

                  <td class="text-center">
                    <i title="Remove Formation Top" class="pi pi-trash !text-red-400"
                    [ngClass]="{ 'opacity-50': rIdx === 0 }"
                    (click)="rIdx !== 0 && onDeleteFormation(rIdx)">
                 </i>
                 
                  </td>
                </tr>
              </ng-container>
            </ng-template>
          </p-table>
        </ng-container>
      </div>
    </form>
  </div>
  }

  @if (tablePlotSelected === 'plot') {
    <app-xy-line-plot [plotData]="plot.data"
      [xAxisTitle]="xAxisTitle" [yAxisTitle]="yAxisTitle" [plotName]="plotName" [downloadPlotName]="downloadPlotName"
      [plotTitle]="'Formation Tops'"
      [xyLinePlotStore]="formationTopsStore" 
    ></app-xy-line-plot>
  }
</app-tool-loader>